/**
 * Video Poster Click-to-Play (Lightbox)
 *
 * Shows thumbnail + play button. Click to open video in fullscreen lightbox.
 * Used on testimonial pages for public S3 videos.
 *
 * Usage: Add class "wpcore-video-poster" and data-video-url="..." to container.
 */

const createLightbox = () => {
	const overlay = document.createElement('div');
	overlay.id = 'wpcore-video-lightbox';

	Object.assign(overlay.style, {
		display: 'none',
		position: 'fixed',
		inset: '0',
		zIndex: '99999',
		background: 'rgba(0,0,0,0.92)',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '24px',
	});

	const closeBtn = document.createElement('button');
	Object.assign(closeBtn.style, {
		position: 'absolute',
		top: '16px',
		right: '16px',
		zIndex: '1',
		width: '44px',
		height: '44px',
		borderRadius: '50%',
		background: 'rgba(255,255,255,0.15)',
		border: 'none',
		color: '#fff',
		fontSize: '28px',
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		transition: 'background 0.2s',
	});
	closeBtn.textContent = '\u00D7';
	closeBtn.addEventListener('mouseenter', () => { closeBtn.style.background = 'rgba(255,255,255,0.3)'; });
	closeBtn.addEventListener('mouseleave', () => { closeBtn.style.background = 'rgba(255,255,255,0.15)'; });

	const player = document.createElement('video');
	player.id = 'wpcore-video-lightbox-player';
	player.controls = true;
	player.playsInline = true;
	Object.assign(player.style, {
		maxWidth: '100%',
		maxHeight: '100%',
		borderRadius: '8px',
		outline: 'none',
	});

	overlay.appendChild(closeBtn);
	overlay.appendChild(player);
	document.body.appendChild(overlay);

	const close = () => {
		player.pause();
		player.removeAttribute('src');
		player.load();
		overlay.style.display = 'none';
		document.body.style.overflow = '';
	};

	const open = (url) => {
		player.src = url;
		overlay.style.display = 'flex';
		document.body.style.overflow = 'hidden';
		player.play().catch(() => {});
	};

	closeBtn.addEventListener('click', close);
	overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && overlay.style.display === 'flex') close();
	});

	return { open };
};

export const initVideoPoster = () => {
	const posters = document.querySelectorAll('.wpcore-video-poster[data-video-url]');
	if (!posters.length) return;

	const lightbox = createLightbox();

	posters.forEach((poster) => {
		if (poster.dataset.videoPosterInit) return;
		poster.dataset.videoPosterInit = '1';

		poster.addEventListener('click', () => {
			const url = poster.dataset.videoUrl;
			if (url) lightbox.open(url);
		});
	});
};
